import useCustomTooltipStyles from './CustomTooltip.styles';

interface Props {
	title: string;
}

const CustomTooltip: React.FC<React.PropsWithChildren<Props>> = ({ children, title }) => {
	const classes = useCustomTooltipStyles();

	return (
		<div className={classes.root}>
			{children}
			<span className={classes.tooltip}>{title}</span>
		</div>
	);
};

export default CustomTooltip;
